<script setup lang="ts">
import { appTitle } from './io'

useHead({
  title: appTitle,
})

const { initTypeScales } = useScale()

const route = useRoute()
const routeName = computed(() => route.name)

watch(routeName, (newName) => {
  initTypeScales({
    fontSize: 18,
    layoutSize: 16,
    layoutRatio: 1.2,
    gridRatio: 1.6,
    ratio: 1.20,
  }, {
    550: {
      fontSize: 17,
      gridRatio: 1.5,
      ratio: 1.2,
    },
    1024: {
      fontSize: 16,
      gridRatio: 1.6,
      ratio: 1.25,
    },
    1440: {
      fontSize: 17,
      gridRatio: 1.5,
      ratio: 1.20,
    },
  })
}, { immediate: true })


</script>


<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="scss">

@use '@/assets/scss/palette.scss' as *;

@use '@/assets/scss/scale.scss' as *;
@use '@/assets/scss/scale-layout.scss' as *;

// Global Components

@use '@/assets/scss/vendors/_normalize.scss' as *;

@use '@/assets/scss/components/buttons.scss' as *;
@use '@/assets/scss/components/forms.scss' as *;
@use '@/assets/scss/components/formfields.scss' as *;
@use '@/assets/scss/components/selectbutton.scss' as *;

@use '@/assets/scss/transitions.scss' as *;

// IO customisations
// Header
@use '@/assets/scss/io/io-header.scss' as *;
// Mega Menu
@use '@/assets/scss/io/io-mega-menu.scss' as *;




@import url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap');




:root {

  interpolate-size: allow-keywords;
  --tippy-text: white;
  --tippy-bg: #2962ff;
  // Primevue Overides
  --p-card-background: white !important;

}


html,
body,

#__nuxt {
  height: 100vh;
  margin: 0;
  padding: 0;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-smoothing: grayscale;

  box-sizing: content-box;

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: grayscale;
    box-sizing: border-box;
  }

  // font-family: 'Inter', sans-serif;
}


.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}

.rotate-enter-active,
.rotate-leave-active {
  transition: all 0.4s;
}
.rotate-enter-from,
.rotate-leave-to {
  opacity: 0;
  transform: rotate3d(1, 1, 1, 15deg);
}
</style>
